import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
export default function slider() {
  const elem_container = '.js-hero__slider';
  if (document.querySelector(elem_container)) {
    const lengthTotal = document.querySelectorAll('.js-hero__slider').length;
    const mySwiper = new Swiper(elem_container, {
      modules: [Navigation, EffectFade, Autoplay, Pagination],
      slidesPerView: 1,
      loop: true,
      effect: 'fade',
      autoplay: {
        delay: 4000,
      },
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }
}
